"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EAnchoringStatus;
(function (EAnchoringStatus) {
    EAnchoringStatus["QUEUED"] = "QUEUED";
    EAnchoringStatus["ATTEMPTING"] = "ATTEMPTING";
    EAnchoringStatus["VERIFIED_ON_CHAIN"] = "VERIFIED_ON_CHAIN";
    EAnchoringStatus["VERIFYING_ON_CHAIN"] = "VERIFYING_ON_CHAIN";
    EAnchoringStatus["ABANDONED"] = "ABANDONED";
})(EAnchoringStatus || (EAnchoringStatus = {}));
exports.default = EAnchoringStatus;
